/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
document.addEventListener("DOMContentLoaded", function () {
  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  }

  let endTimeG;

  function cutDownTime() {
    let nowTime = new Date();
    let endTime = new Date(endTimeG);

    let leftTime = endTime.getTime() - nowTime.getTime();
    if (leftTime < 0) {
      setupNewCountdown();
      leftTime = 0;
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60);
    leftH = leftH >= 10 ? leftH : "0" + leftH;
    leftM = leftM >= 10 ? leftM : "0" + leftM;
    leftS = leftS >= 10 ? leftS : "0" + leftS;

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    };
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9);
    const currentTime = new Date();
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
  }
  let intervalId;

  function getCutDownTime() {
    setupNewCountdown();
    if (intervalId) clearInterval(intervalId);
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime();
      $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
      $(".sp_top_cut_down .sp_left_view .sp_minute").html(
        cutDownTimeText.minute
      );
      $(".sp_top_cut_down .sp_left_view .sp_second").html(
        cutDownTimeText.second
      );
    }, 1000);
  }

  getCutDownTime();

  let spImgList = [
    "https://cdn.shopify.com/s/files/1/0686/1334/1384/files/202510293-p1.png",
    "https://cdn.shopify.com/s/files/1/0686/1334/1384/files/202510293-p2.png",
    "https://cdn.shopify.com/s/files/1/0686/1334/1384/files/202510293-p3.png",

    "https://cdn.shopify.com/s/files/1/0686/1334/1384/files/202510293-b1.png",
    "https://cdn.shopify.com/s/files/1/0686/1334/1384/files/202510293-b2.png",
    "https://cdn.shopify.com/s/files/1/0686/1334/1384/files/202510293-b3.png",

    "https://cdn.shopify.com/s/files/1/0686/1334/1384/files/202510293-c1.png",
    "https://cdn.shopify.com/s/files/1/0686/1334/1384/files/202510293-c2.png",
    "https://cdn.shopify.com/s/files/1/0686/1334/1384/files/202510293-c3.png",

    "https://cdn.shopify.com/s/files/1/0686/1334/1384/files/202510293-d1.png",
    "https://cdn.shopify.com/s/files/1/0686/1334/1384/files/202510293-d2.png",
    "https://cdn.shopify.com/s/files/1/0686/1334/1384/files/202510293-d3.png",
    "https://cdn.shopify.com/s/files/1/0686/1334/1384/files/202510293-d4.png",
    "https://cdn.shopify.com/s/files/1/0686/1334/1384/files/202510293-d5.png",
    "https://cdn.shopify.com/s/files/1/0686/1334/1384/files/202510293-d6.png",
    "https://cdn.shopify.com/s/files/1/0686/1334/1384/files/202510293-e1.png",
    "https://cdn.shopify.com/s/files/1/0686/1334/1384/files/202510293-e2.png",
    "https://cdn.shopify.com/s/files/1/0686/1334/1384/files/202510293-e3.png",
    "https://cdn.shopify.com/s/files/1/0686/1334/1384/files/202510293-e4.png",
    "https://cdn.shopify.com/s/files/1/0686/1334/1384/files/202510293-e5.png",
    "https://cdn.shopify.com/s/files/1/0686/1334/1384/files/202510293-e6.png",
  ];
  new Swiper(".sp-swiper0", {
    spaceBetween: 10,
    loop: true,
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    pagination: {
      el: ".sp-pagination1",
      type: "bullets",
      clickable: true,
    },
  });

  new Swiper(".sp-swiper2", {
    spaceBetween: 10,
    loop: true,
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    pagination: {
      el: ".sp-pagination2",
      type: "bullets",
      clickable: true,
    },
  });
  new Swiper(".sp-swiper3", {
    spaceBetween: 11,
    loop: true,
    slidesPerView: "auto",
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 1,
    },
    speed: 4000,
  });

  new Swiper(".sp-swiper1", {
    spaceBetween: 10,
    loop: true,
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    pagination: {
      el: ".sp-pagination1",
      type: "bullets",
      clickable: true,
    },
  });

  function mainRender() {
    $(function () {
      $("#root").css("zoom", "normal");
      let scale = document.body.clientWidth / 1080;
      $("#root").css("zoom", scale);

      window.addEventListener(
        "resize",
        (function () {
          var timer;
          return function () {
            if (timer) clearTimeout(timer);
            timer = setTimeout(function () {
              $("#root").css("zoom", "normal");
              let scale = document.body.clientWidth / 1080;
              $("#root").css("zoom", scale);
            }, 100);
          };
        })()
      );
    });

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
      const config = {
        rootMargin: "0px 0px 1300px 0px",
        threshold: 0,
      };

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target;
            const dataSrc = image.getAttribute("data-src");
            image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image); // 停止观察该图片
          }
        });
      },
      config);

      images.forEach(function (image) {
        lazyLoadObserver.observe(image); // 开始观察每个图片
      });
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach((subArray) => {
          subArray.forEach((url) => {
            const img = new Image();
            img.src = url;
          });
        });
      } else {
        // 处理一维数组
        imageArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      }
    }

    lazyLoadImages();

    preloadImages(spImgList);

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        let _topHeight =
          $(".time-part").height() +
          $(".sp-header-top").height() +
          $(".sp-nav").height();
        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            _topHeight * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    var isAndroid = /android/i.test(userAgent);
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log("Android");
    } else if (isIOS) {
      console.log("iOS");
    } else if (isPC) {
      console.log("PC");
    } else {
      $(".sp_system").css("letter-spacing", "-4px");
    }
  }

  mainRender();

  let sp_price1 = (window.product[0].price / 100).toFixed(2);
  let sp_price2 = (window.product[0].compare_at_price / 100).toFixed(2);

  let sp_price3 = (window.product[1].price / 100).toFixed(2);
  let sp_price4 = (window.product[1].compare_at_price / 100).toFixed(2);
//    sp_price1 = sp_price1.replace('.', ',');
//    sp_price2 = sp_price2.replace('.', ',');
  let prods = window.product;


  function calcTotal(price, num) {
    let result = Number(price) * Number(num);
    // result = result;
    return result.toFixed(2).replace('.', ',');
  }
  
  $('.sp-bundle-check').on('click',function(){
    

  let sp_price1 = (window.product[0].price / 100).toFixed(2);
  let sp_price3 = (window.product[1].price / 100).toFixed(2);

  console.log($(this).parent('.sp-product-box').hasClass('active'),"111")
  
  if($(this).parent('.sp-product-box').hasClass('active')){
    $(this).parent('.sp-product-box').removeClass('active');
  }else{
    $(this).parent('.sp-product-box').addClass('active');
  }
    let bundle_check = $(this).parent('.sp-product-box').hasClass('active')
    let number1 = 0;
    let number2 = 0;
    if(bundle_check === false){
      number1 = $('.sp-product-box1 .calcNumber').val() || 1;
      calcTotal(sp_price1,number1)
      $("#sp_price1").html(calcTotal(sp_price1, number1));
      $("#sp_price2").html(calcTotal(sp_price2, number1));
    }else{
      number2 = $('.sp-product-box2 .calcNumber').val() || 1;
      // sp_price = sp_price3;
      $("#sp_price1").html(calcTotal(sp_price3, number2));
      $("#sp_price2").html(calcTotal(sp_price4, number2));
    }
})

  $('.sp-btn-style').click(function(){
      let num = $('.calcNumber').val() || 1
      let id = $(this).data("id")
       window.location.href = '/cart/' + id + ':' + num
  })

  $(".sp-reduce").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) - 1;
    if (num > 0) {
      input.value = num;
    }

    $("#sp_price1").html(calcTotal(sp_price1, input.value));
    $("#sp_price2").html(calcTotal(sp_price2, input.value));
    $("#sp_price3").html(calcTotal(sp_price3, input.value));
    $("#sp_price4").html(calcTotal(sp_price4, input.value));
  });
  $(".sp-add").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) + 1;
    input.value = num;
    $("#sp_price1").html(calcTotal(sp_price1, input.value));
    $("#sp_price2").html(calcTotal(sp_price2, input.value));
    $("#sp_price3").html(calcTotal(sp_price3, input.value));
    $("#sp_price4").html(calcTotal(sp_price4, input.value));
  });



  // 标题文本渐出
  const graduallyList = document.getElementsByClassName("gradually");
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll("span");
    const paragraph = gradually.querySelector(".sp-sub-title");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`;
              span.style.animationDelay = `${index * 0.1}s`;

              const i = span.querySelector("i");
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`;
                i.style.animationDelay = `${index * 0.1}s`;
              }
            });

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3;
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade 0.5s ease forwards`;
              paragraph.style.animationDelay = `${totalDelay}s`;
            }

            observer.unobserve(gradually);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observer.observe(gradually);
  }

  // 文本渐出动画
  const graduallyList2 = document.getElementsByClassName("sp-fade-box");
  for (let gradually2 of graduallyList2) {
    const paragraph2 = gradually2.querySelectorAll(".sp-ani");

    const observerAni = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            paragraph2.forEach((span, index) => {
              span.style.animation = `sp-fade-in 1s ease forwards`;
              span.style.animationDelay = `${index * 0.5 + 0.5}s`;
            });

            observerAni.unobserve(gradually2);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observerAni.observe(gradually2);
  }

  // 问答
  $(".q-row").click(function () {
    $(this).parent().toggleClass("sp-show");
  });

  // 数字递增
  let spnum = 732978649;

  setInterval(() => {
    spnum += 1;
    let result = String(spnum)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    $("#updateNum").text(result);
  }, 1000);
});
